import React from 'react';
import { Link } from 'react-router-dom';
import NewsImage from '../components/NewsImage';
import { useNews } from '../components/NewsContext';
import AnimatedNewsBlock from '../components/AnimatedNewsBlock';
import NewsSkeleton from '../components/NewsSkeleton';
import CategoryIcon from '../components/CategoryIcon';
import '../styles/GeneralNewsList.css';

const GeneralNewsList = ({ newsPerPage = 31 }) => {
  const { newsList, firstLoadDone } = useNews();
  const visibleNews = newsList.slice(0, newsPerPage);

  if (!firstLoadDone && visibleNews.length === 0) {
    return <NewsSkeleton count={12} variant="general" />;
  }

  return (
    <AnimatedNewsBlock currentPage={1}>
      <div className="news-container-general">
        {visibleNews.map((news) => (
          <div key={news.id} className="news-card-general">
            <NewsImage
              news={news}
              alt={news.title}
              className="news-image-general"
              loading="lazy"
            />

            <div className="news-content-general">
              <Link to={`/news/${news.id}`} className="news-title-general">
                {news.title}
              </Link>

              <div className="news-meta-general">
                <span className="news-date-general">
                  {news.day}.{news.month}.{news.year} {news.time}
                </span>

                <CategoryIcon news={news} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </AnimatedNewsBlock>
  );
};

export default GeneralNewsList;
